// import C$167:7916$ from "F$167:7916$";
import TypePlaceSensitivtyVariant4 from './TypePlaceSensitivtyVariant4'

const CardVerticalPlace = () => {

  return (
    <div className="self-stretch flex-1 rounded-3xl bg-light overflow-hidden flex flex-col items-center justify-start gap-[16px] text-left text-xs text-dark font-footnote border-b-[4px] border-solid border-lavender">
      <img className="self-stretch relative max-w-full overflow-hidden h-[233px] shrink-0 object-cover" alt="" src="/urlimage1@2x.png" />
      <div className="self-stretch flex flex-col pt-4 px-4 pb-8 items-start justify-start gap-[32px]">
        <div className="self-stretch flex flex-col items-start justify-start gap-[16px]">
          <div className="self-stretch flex flex-row items-start justify-start gap-[16px] text-5xl">
            <img className="relative rounded-11xl w-11 h-11 object-cover" alt="" src="/rectangle-201@2x.png" />
            <b className="flex-1 relative">Secret Playground</b>
          </div>
          <div className="self-stretch flex flex-row pt-0 px-0 pb-2 items-center justify-start gap-[4px] border-b-[1px] border-solid border-darkslategray-200">
            <div className="bg-gold flex flex-row items-center justify-start">
              <b className="relative">Place</b>
            </div>
            <div className="relative rounded-[50%] bg-dark w-1 h-1" />
            <div className="relative">134 1st Ave, New York, NY</div>
          </div>
          <b className="relative">Good for the following sensitivities</b>
          <div className="self-stretch flex flex-row flex-wrap items-start justify-start gap-[6px] text-sm font-h2-accent"><TypePlaceSensitivtyVariant4 iconSet="/icon-set5.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#fbcd2b" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set9.svg" lifestyle="Crowd" typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#fbcd2b" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set10.svg" lifestyle="Handicapped" typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#fbcd2b" iconSetOverflow="hidden" iconSetFlexShrink="0" />
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
            <div className="rounded bg-gold hidden flex-row p-2.5 items-center justify-center gap-[10px]">
              <img className="relative w-6 h-6" alt="" src="/icon-set5.svg" />
              <div className="relative font-medium">{`Visual `}</div>
            </div>
          </div>
        </div>
        <div className="self-stretch flex flex-row py-0 pr-0 pl-4 items-start justify-start text-xl font-h2-accent border-l-[4px] border-solid border-gold">
          <div className="flex-1 relative font-medium">“I go here regularly with my patient at Noon and despite the location, the noise levels, lighting and food textures are great!”</div>
        </div>
      </div>
    </div>);
};

export default CardVerticalPlace;
